import React from 'react'
import useIsInViewport from 'use-is-in-viewport'

import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'


const AdminAside = ({ contacts }) => {

    const nomberRegistedContacts = contacts.reduce((accumulator, currentValue) => {
        if(currentValue.isRegister) return accumulator + 1
        return accumulator
    }, 0)

    return (
        <aside className="asideAdmin flex flex-col space-y-3">
            <StatisticCard text="démandes reçus" num={contacts.length} />
            <StatisticCard text="démandes enregistrés" num={ nomberRegistedContacts } classe="mt-10" />
        </aside>
    )
}

const StatisticCard = ({ text, num, classe }) => {

    const formatNum = (num) => {
        if (num > 10) return num
        return `0${num}`
    }

    return(
        <article className={`${classe} w-full h-48 flex flex-col justify-center p-5 bg-custom-gray rounded-md`}>
             <strong className="text-5xl letterSpacing-10 text-secondary">{formatNum(num)}</strong>
             <Paragraph classe="mt-1">{text.toUpperCase()}</Paragraph>
        </article>
    )
}

export default AdminAside